export interface Holiday {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  status: number;
  createdBy: CreatedBy;
  updatedBy?: unknown;
  ownerList?: unknown;
  deletedBy?: string;
  countryId: number;
  year: number;
  name: string;
  nativeName: string;
  fromDate: string;
  toDate: string;
  totalDays: number;
  dateType: number;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export interface HolidayListRequest {
  page?: number;
  limit?: number;
  name?: string | null;
  year?: number | null;
  status?: number | null;
}

export interface HolidayCreateRequest {
  dateType: number;
  year: number;
  name: string;
  nativeName?: string;
  fromDate: string;
  toDate: string;
  status: number;
}

export interface HolidayUpdateRequest extends HolidayCreateRequest {
  id: string;
}

export interface HolidayListResponse extends RestAPIMetaResponse {
  items: Array<Holiday>;
}

export enum HolidayDateType {
  WEEKDAY = 1,
  WEEKEND_HOLIDAY = 3,
  PUBLIC_HOLIDAY = 5,
}
